import type { ComponentSize } from '../../constants'
import { componentSizes } from '../../constants'

export const isValidComponentSize = (val: string) : val is ComponentSize | '' => {
    return ['', ...componentSizes].includes(val)
}
